import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';

// Components
import SettingsButton from './SettingsButton';
import {
    ContainerStyled,
    ContainerClickableStyled,
    ContainerInnerStyled,
    LastMessageTimeStyled,
    LastMessageTextStyled,
    NameStyled,
    NewMessagesBadgeStyled,
} from './InboxConversationItemStyled';

import CardMemberAvatar from '@atoms/CardMemberAvatar';

// Functionality
import { formatShortTime } from './helpers.date';
import useConversationMessages from './hooks/useConversationMessages';
import useCurrentParticipantMember from './hooks/useCurrentParticipantMember';
import useConversationParticipants from './hooks/useConversationParticipants';
import useConversationUnread from './hooks/useConversationUnread';
import { ConversationsContext } from '../../../context/ConversationsProvider';

const InboxConversationItem = ({ conversation, isActive = false, onClickItem }) => {
    const { currentConversation } = useContext(ConversationsContext);
    const unreadCount = useConversationUnread(conversation, currentConversation);
    const { firstPageMessageData } = useConversationMessages(conversation);
    const { viewerParticipant } = useConversationParticipants(conversation);
    const { currentParticipantMember } = useCurrentParticipantMember(conversation);

    if (!currentParticipantMember || !viewerParticipant) return null;

    return (
        <ContainerStyled>
            <ContainerClickableStyled isActive={isActive} onClick={() => onClickItem(conversation)}>
                <ContainerInnerStyled>
                    <div style={{ width: '48px' }}>
                        <CardMemberAvatar
                            firstName={currentParticipantMember.firstName}
                            lastName={currentParticipantMember.lastName}
                            photoURL={currentParticipantMember.photoURL}
                            sizeDesktop={48}
                            sizeMobile={48}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginLeft: '15px',
                            minWidth: 0,
                            flex: '1 100%',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <NameStyled hasNew={unreadCount > 0}>
                                    {currentParticipantMember.firstName} {currentParticipantMember.lastName}
                                </NameStyled>
                                {unreadCount > 0 && <NewMessagesBadgeStyled>{unreadCount}</NewMessagesBadgeStyled>}
                            </div>
                            {firstPageMessageData?.items?.length > 0 && (
                                <LastMessageTimeStyled>
                                    {formatShortTime(
                                        firstPageMessageData.items[firstPageMessageData.items.length - 1].state
                                            .timestamp
                                    )}
                                </LastMessageTimeStyled>
                            )}
                        </div>
                        {firstPageMessageData?.items?.length > 0 && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'stretch',
                                }}
                            >
                                <LastMessageTextStyled hasNew={unreadCount > 0}>
                                    {firstPageMessageData.items[firstPageMessageData.items.length - 1].state.body}
                                </LastMessageTextStyled>
                            </div>
                        )}
                    </div>
                </ContainerInnerStyled>
            </ContainerClickableStyled>
            <SettingsButton conversation={conversation} />
        </ContainerStyled>
    );
};
InboxConversationItem.propTypes = {
    conversation: PropTypes.any,
    isActive: PropTypes.bool,
    onClickItem: PropTypes.func,
};

export default InboxConversationItem;
